<template lang="pug">
  b-modal#clearOutstanding(
  ref="clearOutstanding"
  :title="$t('ui.combine.clear_outstanding')"
  centered
  no-fade
  no-close-on-backdrop
  :busy="loading"
  @ok="done"
  @show="reset"
  @shown="shown")
    b-form(novalidate :disabled="!feedback.success" @submit.stop.prevent="submit")
      b-form-group(:label="$t('ui.account_id')" disabled).mb-0
        DebounceInput(
          size="sm"
          ref="account_id"
          required
          type="text"
          :dirty="$v.account_id.$dirty"
          :error="$v.account_id.$error"
          v-model.trim.lazy="$v.account_id.$model"
          :disabled="loading"
        )
        ValidateResult(:value="$v.account_id" :name="$t('ui.account_id')")
      b-form-group(:label="$t('ui.game_balance')" disabled).mb-0
        DebounceInput(
          size="sm"
          ref="game_balance"
          type="text"
          v-model="game_balance"
          :disabled="loading"
        )
      b-form-group(:label="$t('ui.outstanding_balance')" disabled).mb-0
        DebounceInput(
          size="sm"
          ref="outstanding_balance"
          type="text"
          v-model="outstanding_balance"
          :disabled="loading"
        )
      b-form-group(:label="$tc('ui.remark')").mb-0
        DebounceInput(
          size="sm"
          ref="remark"
          required
          type="text"
          :dirty="$v.remark.$dirty"
          :error="$v.remark.$error"
          v-model.trim.lazy="$v.remark.$model"
          :disabled="loading"
        )
        ValidateResult(:value="$v.remark" :name="$t('ui.remark')")
      b-form-group(:label="$t('ui.last_update_time')" disabled).mb-0
        DebounceInput(
          size="sm"
          ref="last_update_time"
          type="text"
          v-model="last_update_time"
          :disabled="loading"
        )
      b-form-group(:label="$t('ui.trace')").mb-0
        SubmitButton(
          :loading="loading"
          icon="fa fa-search"
          :text="$t('ui.trace')"
          type="button"
          @click="traceOutstanding()"
          variant="info"
          size="sm"
          )
      b-form-group.mb-0(v-if="showTrace && pageLvl == 'summary'" :label="$t('ui.outstanding')")
        div.row.mb-3.animated.fadeIn
          div.col
            table.tablex(style="width: 100%;")
              thead
                tr
                  th.sticky-position(width="3%")
                    span #
                  th.sticky-position(width="9%")
                    span(:title="$t('ui.provider_code')") {{ $t("ui.provider_code") }}
                  th.sticky-position(width="8%")
                    span(:title="$t('ui.outstanding')") {{ $t("ui.outstanding") }}
              tbody
                tr(v-if="outstandingList.length == 0")
                  td(colspan="3").text-center
                    span {{ $t('message.no_data_available') }}
                tr(v-for="(item, index) in outstandingList")
                  td
                    span(:title="index + 1") {{ index + 1 }}
                  td
                    //- span(:title="item.provider_code") {{ item.provider_code }}
                    span(:title="item.provider_code" v-if="['EPIC2','MEGAH5'].includes(item.provider_code)")
                      b-link.clickable(href="javascript:void(0);" @click="setProvider(item)") {{ item.provider_code }}
                    span(:title="item.provider_code" v-else) {{ item.provider_code }}
                  td
                    span(:class="$helpers.fontClassName(item.outstanding)" :title="$n(item.outstanding, 'currency')") {{ $n(item.outstanding, 'currency') }}
      b-form-group.mb-0(v-if="showTrace && pageLvl == 'detail'" :label="$t('ui.unfinish_round')")
        SubmitButton(
          :loading="loading"
          icon="icon-arrow-left"
          :text="$t('ui.back')"
          type="button"
          @click="backToSummaryLvl"
          variant="secondary"
          size="sm"
          ).mb-2
        div.row.mb-3.animated.fadeIn
          div.col
            table.tablex(style="width: 100%;")
              thead
                tr
                  th.sticky-position(width="3%")
                    span #
                  th.sticky-position(width="9%")
                    span(:title="$t('ui.round_id')") {{ $t("ui.round_id") }}
                  th.sticky-position(width="9%")
                    span(:title="$t('ui.game_id')") {{ $t("ui.game_id") }}
                  th.sticky-position(width="9%")
                    span(:title="$t('ui.game_name')") {{ $t("ui.game_name") }}
                  th.sticky-position(width="8%")
                    span
              tbody
                tr(v-if="roundList.length == 0")
                  td(colspan="5").text-center
                    span {{ $t('message.no_data_available') }}
                tr(v-for="(item, index) in roundList")
                  td
                    span(:title="index + 1") {{ index + 1 }}
                  td
                    span(:title="item.RoundId") {{ item.RoundId }}
                  td
                    span(:title="item.GameId") {{ item.GameId }}
                  td
                    span(:title="item.GameName") {{ item.GameName }}
                  td.text-center
                    SubmitButton(
                      :loading="loading"
                      icon="fa fa-ban"
                      :text="$t('ui.cancel')"
                      type="button"
                      @click="cancelRound(item)"
                      variant="warning"
                      size="sm"
                      )
      div.row
        div.col
          b-alert.animated.flash(:show="!feedback.success" variant="bottom") {{ $t("error." + feedback.status) }}
    div(slot="modal-cancel")
      SubmitButton(:loading="loading" icon="fa fa-ban" :text="$t('ui.cancel')" isModal=true)
    div(slot="modal-ok" v-if="showActionButton('clearoutstanding') == true")
      SubmitButton(:loading="loading" icon="fa fa-eraser" :text="$t('ui.clear')" isModal=true)
</template>

<script>
import { required, alphaNum, minLength, maxLength, integer, numeric, helpers, decimal } from "vuelidate/lib/validators";
import config from "@/config";
import errorTags from "@/errorTags";
import SubmitButton from "@/library/SubmitButton";
import ValidateResult from "@/library/ValidateResult";
import DebounceInput from "@/library/DebounceInput";
const alphaNumWithSpace = helpers.regex("alphaNumWithSpace", /^[a-z\d\-_\s]+$/i);

export default {
  components: {
    SubmitButton,
    ValidateResult,
    DebounceInput,
  },
  props: {
    item: {
      type: Object,
      default: {}
    },
  },
  data() {
    return {
      account_id: "",
      game_balance: "",
      outstanding_balance: "",
      last_update_time: "",
      remark: "",
      adjusted_amount: "",
      walletList: [],
      clearList: [],
      outstandingList: [],
      showTrace: false,
      loading: false,
      feedback: {
        success: true,
        status: ""
      },
      pageLvl: 'summary',
      selectedProvider: null,
      roundList: [],
    };
  },
  computed: {
    on() {
      return this.$t("ui.on");
    },
    off() {
      return this.$t("ui.off");
    },
    getAuthorityRole() {
      if (this.$store.getters.authorityRole)
        return this.$store.getters.authorityRole;

      return '';
    },
  },
  validations: {
    account_id: {
      required,
      alphaNum,
      minLength: minLength(6),
      maxLength: maxLength(20)
    },
    remark: {
      required,
      maxLength: maxLength(255)
    }
  },
  methods: {
    showActionButton(action) {
      if (this.getAuthorityRole == 'SUB_PRI') {
        if (this.$store.getters.accountAuthority) {
          var roles = this.$store.getters.accountAuthority[0].authority_option;
          roles =  roles && roles.length > 0 ? roles.split(',') : [];
          if (roles.includes(action))
            return true;
          else
            return false;
        } else
          return false;
      } else {
        return true;
      }
    },
    done: function(evt) {
      evt.preventDefault();
      this.submit();
    },
    getMemberWallet: function() {
      let url = config.memberWalletGetUrl();

      var json = {
        action_by: this.$store.getters.loginId,
        auth_token: this.$store.getters.sessionToken,
        member_id: this.item.account_id,
        audit_by: this.$store.getters.loginId
      };

      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.walletList = response.data.dt;
                this.account_id = this.walletList.length > 0 ? this.walletList[0].account_id : "";
                this.game_balance = this.walletList.length > 0 ? this.$n(this.walletList[0].game_balance, 'currency') : "";
                this.outstanding_balance = this.walletList.length > 0 ? this.$n(this.walletList[0].outstanding_balance, 'currency') : "";
                this.last_update_time = this.walletList.length > 0 ? (this.walletList[0].last_update_time ? this.$moment(this.walletList[0].last_update_time).format("YYYY-MM-DD, HH:mm:ss") : "") : "";
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    traceOutstanding: function() {
      this.$helpers
      .alert({
        title: this.$t("ui.trace_outstanding"),
        text: this.$t("message.trace_outstanding_confirm", { name: this.account_id }),
        type: "question",
        showCancelButton: true
      })
      .then(result => {
        if (result.value) {
          this.confirmTraceOutstanding();
        }
      });
    },
    confirmTraceOutstanding: function() {
      let url = config.traceOutstandingUrl();

      var json = {
        action_by: this.$store.getters.loginId,
        auth_token: this.$store.getters.sessionToken,
        member_id: this.item.account_id,
        audit_by: this.$store.getters.loginId
      };

      this.showTrace = false;
      this.outstandingList = [];

      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.showTrace = true;
                this.pageLvl = 'summary';
                this.outstandingList = response.data.dt;
              } else {
                // if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            // this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          // this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    backToSummaryLvl() {
      this.pageLvl = "summary";
      this.roundList = [];
      this.selectedProvider = null;
      this.confirmTraceOutstanding();
    },
    getRoundList: function() {
      let url = "";

      if (this.selectedProvider == 'EPIC2')
        url = config.epic2GetUnfinishRoundUrl();
      else if (this.selectedProvider == 'MEGAH5')
        url = config.megah5GetUnfinishRoundUrl();

      var json = {
        action_by: this.$store.getters.loginId,
        auth_token: this.$store.getters.sessionToken,
        account_id: this.$store.getters.accountId,
        member_id: this.item.account_id
      };

      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.pageLvl = 'detail';
                this.roundList = response.data.dt;
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    setProvider: function (e) {
      this.selectedProvider = e.provider_code;
      this.roundList = [];
      this.getRoundList();
    },
    cancelRound: function(item) {
      this.$helpers
        .alert({
          title: this.$t("ui.status"),
          text: this.$t("message.cancel_unfinish_round_confirm", { round: item.RoundId }),
          type: "question",
          showCancelButton: true
        })
        .then(result => {
          if (result.value) {
            this.confirmCancelRound(item);
          } else {
            this.getRoundList();
          }
        });
    },
    confirmCancelRound: function(item) {
      let url = "";
      if (this.selectedProvider == 'EPIC2')
        url = config.epic2CancelUnfinishRoundUrl();
      else if (this.selectedProvider == 'MEGAH5')
        url = config.megah5CancelUnfinishRoundUrl();

      var json = {
        action_by: this.$store.getters.loginId,
        auth_token: this.$store.getters.sessionToken,
        account_id: this.$store.getters.accountId,
        member_id: this.item.account_id,
        round_id: item.RoundId
      };

      this.feedback.success = true;
      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              if (typeof response.data.status == "string") {
                this.feedback.success = response.data.status == "1";
              } else {
                this.feedback.success = response.data.status == 1;
              }
              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.getRoundList();
                this.$helpers.showDialog(this.$t("ui.status"), this.$t("message.success"), "success");
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
                //this.$emit("failed", "edit_payment_option_provider", this.feedback.status);
                // this.$refs.editPaymentOptionProvider.hide();
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
        }
      );
    },
    submit: function() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        this.$helpers
        .alert({
          title: this.$t("ui.clear_outstanding"),
          text: this.$t("message.clear_outstanding_confirm", { name: this.account_id }),
          type: "question",
          showCancelButton: true
        })
        .then(result => {
          if (result.value) {
            this.confirmClearOutstanding();
          }
        });
      }
    },
    confirmClearOutstanding: function() {
      let url = config.clearOutstandingUrl();

      var json = {
        action_by: this.$store.getters.loginId,
        auth_token: this.$store.getters.sessionToken,
        account_id: this.$store.getters.accountId,
        member_id: this.item.account_id,
        remark: this.remark,
        audit_by: this.$store.getters.loginId
      };

      this.feedback.success = true;
      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              if (typeof response.data.status == "string") {
                this.feedback.success = response.data.status == "1";
              } else {
                this.feedback.success = response.data.status == 1;
              }
              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.clearList = response.data.dt;
                this.adjusted_amount = this.clearList.length > 0 ? this.clearList[0].adjusted_amount : "";
                this.$emit("clicked", this.adjusted_amount);
                this.$refs.clearOutstanding.hide();
              } else {
                this.$helpers.handleFeedback(this.feedback.status);
                this.$emit("failed", "clear_outstanding", this.feedback.status);
                this.$refs.clearOutstanding.hide();
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
        }
      );
    },
    reset: function() {
      this.feedback.success = true;
      this.feedback.status = "";
    },
    shown: function() {
      this.$v.$reset();
      this.account_id = this.item.account_id;
      this.game_balance = "";
      this.outstanding_balance = "";
      this.last_update_time = "";
      this.remark = "";
      this.showTrace = false;
      this.getMemberWallet();
      this.$refs.remark.$el.focus();
    }
  }
};
</script>
